import type CopilotPrioritizeSettings from "./CopilotPrioritizeSettings";

const defaultCopilotPrioritizeSettings: CopilotPrioritizeSettings = {
    version: 1,
    prioritizationEnabled: false,
    moreImportantRules: [],
    lessImportantRules: [],
    miscellaneousRules: [],
    applyLowPriorityLabel: false,
    replacePreviewWithMicroSummary: true,
};

export default defaultCopilotPrioritizeSettings;
